import { render } from "./ShareModal.vue?vue&type=template&id=67f8b092"
import script from "./ShareModal.vue?vue&type=script&lang=js"
export * from "./ShareModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__